<template>
  <article>
    <main>
      <section>
        <div class="login-box">
          <div class="login-box-left">
            <div class="login-box-logo">
              <img
                src="@/assets/img/logo.png"
                alt=""
                width="54px"
                height="55px"
              />
              <span>
                <h2>报废机动车回收拆解<br />管理系统</h2>
                <!-- <p>Domestic Universal Template</p> -->
              </span>
            </div>
            <!-- <div class="login-box-Loginmode">
              <div class="header">
                <div>其他登录方式</div>
              </div>
            </div> -->
          </div>
          <div class="login-box-right">
            <section v-on:keyup.enter="login">
              <div class="login-content">
                <div class="login-content-top">
                  <span>用户登录</span>
                </div>
                <el-form :model="form" status-icon :rules="rules" ref="form">
                  <el-form-item>
                    <el-input
                      placeholder="企业名称"
                      :disabled="true"
                      v-model.trim="form.Loginenterprise"
                      prefix-icon="ri-building-line"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="Loginname">
                    <el-input
                      placeholder="用户名"
                      v-model.trim="form.Loginname"
                      prefix-icon="ri-user-line"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="Password">
                    <PwdInput
                      v-model.trim="form.Password"
                      placeholder="密码"
                      prefix-icon="ri-lock-line"
                    ></PwdInput>
                  </el-form-item>
                  <el-form-item>
                    <el-button style="width: 100%" type="primary" @click="login"
                      >登录</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </section>
          </div>
        </div>
      </section>
    </main>
  </article>
</template>

<script>
import initStore from "@/common/initStore.js";
import initSignlR from "@/common/signalr.js";
import PwdInput from "@/components/PwdInput.vue";
export default {
  components: {
    PwdInput,
  },
  name: "login",
  data() {
    return {
      form: {
        Loginenterprise: "华燕拆车",
      },
      rules: {
        Loginname: [{ required: true, message: "请输入用户名" }],
        Password: [{ required: true, message: "请输入密码" }],
      },
    };
  },
  watch: {},
  methods: {
    login() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        this.$post("User/Login", {
          ...this.form,
        }).then((r) => {
          sessionStorage["token"] = r.Result;
          initStore();
          initSignlR();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input--small.is-disabled ::v-deep .el-input__inner {
  color: #000 !important;
}
.el-input--small ::v-deep .el-input__inner {
  background-color: #f2f3f5 !important;
  border-width: 0 !important;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  border-radius: 0 !important;
}

.el-input--prefix ::v-deep .el-input__prefix {
  left: 2px;
  right: unset;
  font-size: 16px;
  color: #4e5969;
  margin: 0 5px;
  top: 2px;
}

.el-input--prefix ::v-deep .el-input__suffix {
  top: 6px;
}

.el-input--prefix::v-deep .el-input__inner {
  padding-left: 30px;
}

.el-input--prefix ::v-deep .el-input__suffix {
  right: 10px;
}

.el-button--small {
  padding: 12px 15px;
}

.el-form ::v-deep .el-form-item__content {
  margin-bottom: 10px;
}

.el-form ::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
article {
  position: relative;
  background: url(../assets/img/login-bg.png) no-repeat left bottom;
  background-size: 100%;
  height: 100vh;

  main {
    color: #fff;
    .login-box {
      position: relative;
      top: 180px;
      width: 620px;
      height: 340px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      border-radius: 8px;
      overflow: hidden;
      .login-box-left {
        width: 270px;
        background-image: url(../assets/img/login-img.png);
        background-size: 100%;
        padding: 30px 20px;
        box-sizing: border-box;

        .login-box-logo {
          padding: 40px 0px;
          text-align: center;
          img {
            width: 40px;
            height: 40px;
            margin-bottom: 16px;
          }
          h2 {
            font-size: 20px;
            font-weight: 400;
          }
        }
        .header {
          width: 230px;
          height: 36px;
          line-height: 36px;
          text-align: center;

          position: relative;
          font-size: 14px;
          font-weight: 300;
          top: 30px;
        }
        .header div:before,
        .header div:after {
          position: absolute;
          background: #ffffff;
          content: "";
          height: 0.5px;
          top: 50%;
          width: 54px;
        }
        .header div:before {
          left: 10px;
        }
        .header div:after {
          right: 10px;
        }
      }
      .login-box-right {
        width: 350px;
        background-color: #fff;
      }
    }

    .login-content {
      padding: 36px 30px 20px;

      .login-content-top {
        color: #000;
        margin-bottom: 20px;

        span:nth-child(1) {
          font-size: 20px;
          font-weight: 500;
        }
      }

      .el-form {
        margin-top: 5%;

        .el-input__inner {
          height: 100px !important;
        }
      }
    }
  }
}
</style>